import React from 'react';
import { useTranslation } from 'react-i18next';

const HistoryPage = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-[#f0efed] min-h-screen py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">

        {/* Page header */}
        <div className="mb-12">
          <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight">
            {t('history.title')}
          </h1>
          <div className="mt-3 h-1 w-16 bg-[#1d5cab] rounded-full" />
        </div>

        {/* Intro */}
        <p className="text-lg font-medium text-gray-800 leading-relaxed mb-12">
          {t('history.intro')}
        </p>

        {/* Origins */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-[#1d5cab] mb-4">
            {t('history.origins-title')}
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            {t('history.origins-p1')}
          </p>
          <p className="text-gray-700 leading-relaxed">
            {t('history.origins-p2')}
          </p>
        </section>

        {/* Evolution */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-[#1d5cab] mb-4">
            {t('history.evolution-title')}
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            {t('history.evolution-p1')}
          </p>
          <p className="text-gray-700 leading-relaxed">
            {t('history.evolution-p2')}
          </p>
        </section>

        {/* Invitation callout */}
        <section className="border-l-4 border-[#1d5cab] bg-white rounded-r-xl px-6 py-5 shadow-sm">
          <h2 className="text-base font-bold text-gray-900 uppercase tracking-wide mb-3">
            {t('history.invitation-title')}
          </h2>
          <p className="text-gray-700 leading-relaxed">
            {t('history.invitation')}
          </p>
        </section>

      </div>
    </div>
  );
};

export default HistoryPage;
